import React, { useState, useRef, useEffect } from "react";
import FiltrationCard from "./FiltrationCard";
import ResultCard from "./ResultCard";

import "./style.scss";
import Pagination from "./Pagination";

const Filtration = ({
  articleCategories = {},
  podcastCategories = {},
  posts = [],
  iconFilter,
  isThai,
}) => {
  const resultHeaderRef = useRef(null);
  const _scrollToResultHeader = () => resultHeaderRef.current.scrollIntoView();

  const [selectedTopic, setSelectedTopic] = useState(
    isThai ? "all" : "articles"
  );
  const [selectedArticleCategories, setSelectedArticleCategories] = useState(
    {}
  );
  const [selectedPodcastCategories, setSelectedPodcastCategories] = useState(
    {}
  );
  const defaultSelectedLevel = {
    beginner: true,
    intermediate: true,
    advanced: true,
  };
  const [selectedLevel, setSelectedLevel] = useState(defaultSelectedLevel);

  const [filteredPosts, setFilteredPosts] = useState([]);
  const [page, setPage] = useState(1);
  const LIMIT = 10;
  const totalPage = Math.ceil(filteredPosts.length / LIMIT);

  const _transformCategoriesData = (
    categories = {},
    isActive,
    defaultActiveCategories = []
  ) =>
    categories?.nodes[0]?.wpChildren.nodes.reduce(
      (result, { slug }) => ({
        ...result,
        [slug]: defaultActiveCategories.includes(slug) ? true : isActive,
      }),
      {}
    );

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const topic = search.get("topic");
    const categories = search.get("cat")?.split(",") || [];

    if (topic === "podcasts") {
      const _podcastCategories =
        categories.length > 0
          ? {
              ..._transformCategoriesData(podcastCategories, false, categories),
            }
          : _transformCategoriesData(podcastCategories, true);

      setSelectedTopic(topic);
      setSelectedPodcastCategories(_podcastCategories);
      setSelectedArticleCategories(
        _transformCategoriesData(articleCategories, false)
      );
      setFilteredPosts(_filterCategories(topic, posts, _podcastCategories));
    } else if (topic === "articles") {
      const _articlesCategories =
        categories.length > 0
          ? {
              ..._transformCategoriesData(articleCategories, false, categories),
            }
          : _transformCategoriesData(articleCategories, true);
      setSelectedTopic(topic);
      setSelectedArticleCategories(_articlesCategories);
      isThai &&
        setSelectedPodcastCategories(
          _transformCategoriesData(podcastCategories, false)
        );
      setFilteredPosts(_filterCategories(topic, posts, _articlesCategories));
    } else {
      isThai &&
        setSelectedPodcastCategories(
          _transformCategoriesData(podcastCategories, true)
        );
      setSelectedArticleCategories(
        _transformCategoriesData(articleCategories, true)
      );
      setFilteredPosts(posts);
    }
  }, []);

  const _filterCategories = (topic, posts, categories) =>
    posts.filter((post) => {
      const foundCats = post.categories.nodes.find(
        (cat) =>
          cat.wpParent?.node.slug.split("-")[0] === topic &&
          categories[cat.slug]
      );
      const foundTag = post.tags.nodes.find((tag) => selectedLevel[tag.slug]);

      return foundCats && foundTag;
    });

  const _applyFilters = (topic) => {
    let filtered;
    if (topic === "articles") {
      filtered = _filterCategories(topic, posts, selectedArticleCategories);
    } else if (topic === "podcasts") {
      filtered = _filterCategories(topic, posts, selectedPodcastCategories);
    } else {
      filtered = posts.filter((post) => {
        const foundCats = post.categories.nodes?.find(
          (cat) =>
            (/articles/.test(cat.wpParent?.node.slug) &&
              selectedArticleCategories[cat.slug]) ||
            (cat.wpParent?.node.slug === "podcasts" &&
              selectedPodcastCategories[cat.slug])
        );
        const foundTag = post.tags.nodes.find((tag) => selectedLevel[tag.slug]);

        return foundCats && foundTag;
      });
    }
    setFilteredPosts(filtered);

    setSelectedTopic(topic);
    setPage(1);
  };

  const _resetFilters = () => {
    setSelectedTopic(isThai ? "all" : "articles");
    setSelectedArticleCategories(
      _transformCategoriesData(articleCategories, true)
    );
    isThai &&
      setSelectedPodcastCategories(
        _transformCategoriesData(podcastCategories, true)
      );
    setSelectedLevel(defaultSelectedLevel);

    setFilteredPosts(posts);
    setPage(1);
  };

  return (
    <div id="filtration-results">
      <div className="container">
        <p>Resource Centre</p>
        <h1 className="pb-5">Filtration results</h1>

        <FiltrationCard
          iconFilter={iconFilter.publicURL}
          selectedTopic={selectedTopic}
          selectedArticleCategories={selectedArticleCategories}
          setSelectedArticleCategories={setSelectedArticleCategories}
          selectedPodcastCategories={selectedPodcastCategories}
          setSelectedPodcastCategories={setSelectedPodcastCategories}
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          applyFilters={_applyFilters}
          resetFilters={_resetFilters}
          isThai={isThai}
        />
      </div>

      <div className="results pt-5">
        <h2 className="container mt-3 mb-5" ref={resultHeaderRef}>
          {filteredPosts.length} tagged result for{" "}
          <span className="result-topic">{selectedTopic}</span>
        </h2>
        {filteredPosts.slice((page - 1) * LIMIT, LIMIT * page).map((post) => (
          <ResultCard key={`filtration-result-${post.slug}`} post={post} />
        ))}

        {filteredPosts.length > 10 && (
          <div className="result-pagination d-flex justify-content-center align-items-center mt-5">
            <Pagination
              page={page}
              setPage={setPage}
              totalPage={totalPage}
              scrollToResultHeader={_scrollToResultHeader}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Filtration;
